import { Row, Col } from 'antd'

import Image from 'components/Image'
import Title from 'components/Title'

import asyncComponent from 'utils/asyncComponent'

import Styled from './styled'

const Carousel = asyncComponent(() => import('components/Carousel'))

export default function SectionWhyUs({ data }) {
  const contents = data
  const altImage = contents?.[0].image?.alternativeText

  return (
    <Styled>
      <Carousel
        options={{
          autoplay: {
            delay: 8000,
          },
        }}
        items={contents}
        uiRenderer={item => {
          const image = item?.image?.url
          const title = item?.title
          const subtitle = item?.subTitle
          const description = item?.description
          return (
            <div className="usp-block">
              <Row gutter={[40, 0]}>
                <Col span={24} lg={13}>
                  <div className="left-block">
                    <div className="title-block">
                      <div className="title">
                        <Title level={2} className="font-semibold">
                          {title}
                        </Title>
                      </div>
                      <Title level={3}>{subtitle}</Title>
                      <div className="box-container-mobile">
                        <div className="box" />
                        <div className="box2" />
                        <div className="image-block">
                          <Image src={image} imgixWidth={900} />
                        </div>
                      </div>
                      <div
                        className="description-block"
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                    </div>
                  </div>
                </Col>
                <Col span={24} lg={11}>
                  <div className="right-block">
                    <div className="box-container-desktop">
                      <div className="box" />
                      <div className="box2" />
                      <div className="image-block">
                        <Image src={image} imgixWidth={900} alt={altImage} />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )
        }}
      />
    </Styled>
  )
}
